import { apiSlice } from '../../app/api/apiSlice'

export const passwordResetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    requestPasswordReset: builder.mutation ({
      query: (data) => ({
        url: 'v1/user/passwordresetrequest',
        method: 'POST',
        body: data
      })
    }),
    passwordReset: builder.mutation ({
        query: (data) => ({
          url: 'v1/user/passwordreset',
          method: 'POST',
          body: data
        })
      }),

  }),
})


export const {
  useRequestPasswordResetMutation,
  usePasswordResetMutation
} = passwordResetApi
